import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_62pftzpc9j: FaireBrandEntity = {
  token: "b_62pftzpc9j",
  type: "brand",
  name: "Bowlcut",
  avatarUrl:
    "https://cdn.faire.com/fastly/a8af4db0a0d1b373421c0d0cef8c7ffa301218bbc1e267c268e17ea63332053e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/667916dc728e8c3a140cb17bbed7ad63618090e09072ed1c0c2450e6a3398a09.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a8af4db0a0d1b373421c0d0cef8c7ffa301218bbc1e267c268e17ea63332053e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/667916dc728e8c3a140cb17bbed7ad63618090e09072ed1c0c2450e6a3398a09.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Bowlcut is an AAPI & woman-founded Asian American sauce brand redefining what eating well tastes like for a new generation. Founded by former restaurant kid Crystal Ung, who spent her childhood working at her dad’s Chinese restaurant, Bowlcut creates plant-based sauces inspired by the childhood staples of our past — made in the USA with all-natural ingredients, reduced sodium & sugar and zero artificial additives to let the real flavor speak for itself.  \n\nOur spicy lemongrass won SELF Magazine's Pantry Award for best stir fry sauce.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T06:31:32.752Z",
    importedBy: "entity-db-cli",
  },
};
